const data = [
  {
    title: "Arrival to Earth",
    date: "March 1999",
    text:
      "I was born in Beijing, China. My parents wished that their daughter can have a bright mind and a soul that shines, so they picked 星(xing), which means stars. The meanings behind my name affected me a lot as I grow up.",
    category: {
      tag: "life",
      color: "#364f6b"
    }
  },

  {
    title: "Embarking on a New Journey",
    date: "March 2014",
    text:
      "I moved to Surrey, B.C. to join my mom who moved to Canada earlier that year. Although being a little scared at first, I adapted quickly and learned to embrace new opportunities.",
    category: {
      tag: "life",
      color: "#364f6b"
    }
  },

  {
    title: "Sullivan Heights",
    date: "April 2014-September2015",
    text:
      "I attended Sullivan Heights, a secondary school located in Surrey. Fun fact: I was the school champion of the Cayley Contest(a University of Waterloo math contest) ",
    category: {
      tag: "Education",
      color: "#46cdcf"
    }
  },

  {
    title: "Beautiful Shawnigan Lake",
    date: "September 2016",
    text:
      "My life has been full of adventures. After 2 years of living in Surrey, I transferred to Dwight School Canada, a boarding school in Shawnigan Lake.",
    category: {
      tag: "Education",
      color: "#46cdcf"
    }
  },

  {
    title: "Officially Canadian",
    date: "June 2019",
    text:
      "After 5-ish years of living in Canada, I became certain that I like mapel syrup, (and that I like being nice and being treated nicely eh!:). Canada is the place where I baked my first cake, learned a second(and third, and fourth:) language, got my first paycheque, and met friends and mentors who help me become a better version of myself. It is the place that I call home. ",
    category: {
      tag: "Life",
      color: "#364f6b"
    }
  },

  {
    title: "Marvellous McGill, Montreal",
    date: "September 2017-present",
    text:
      "I don't know what is ahead of me, but I will continue to give 101% to every(important) thing that I do. I look forward to reading and writing the next chapter of my life.",
    category: {
      tag: "???",
      color: "#018f69"
    }
  }
];

export default data;
